import { httpRequest } from "@services/http";
import type { NetworkTemplate } from "@models/networkTemplate.model";

// Network Templates are scoped to organization 4 while the feature runs
// alongside the legacy Network Presets. See networkTemplateService.ts.
const NETWORK_TEMPLATE_ORG_ID = 4;

export class CommandGetNetworkTemplates {
  async run(network?: string): Promise<NetworkTemplate[]> {
    const params = new URLSearchParams({ organization_id: String(NETWORK_TEMPLATE_ORG_ID) });
    if (network) {
      params.set("network", network.toLowerCase());
    }
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content_network/network_templates/?${params.toString()}`;
    return await httpRequest<NetworkTemplate[]>(url, { method: "GET" });
  }
}
